import { Microscope } from "lucide-react";

export const Logo = ({ dark = false, compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="app-logo">
    <div className="h-9 w-9 rounded-md bg-[#002FA7] flex items-center justify-center shrink-0">
      <Microscope className="h-5 w-5 text-white" strokeWidth={2} />
    </div>
    {!compact && (
      <div className="leading-tight">
        <div className={`font-heading font-extrabold text-lg tracking-tight ${dark ? "text-white" : "text-[#111827]"}`}>
          LabTrack<sup className="text-[9px] align-super ml-0.5">TM</sup>
        </div>
        <div className={`text-[10px] uppercase tracking-[0.18em] ${dark ? "text-slate-400" : "text-[#6B7280]"}`}>
          by PathLete<sup className="text-[7px] align-super">®</sup>
        </div>
      </div>
    )}
  </div>
);
